(() => {
  if (window.__bolodooNativeShoesForm) return;
  window.__bolodooNativeShoesForm = true;

  const rows = [
    { us: "6", eu: "35", inch: ["8.9", "3.1"], cm: ["22.5", "7.86"] },
    { us: "6.5", eu: "36", inch: ["9.1", "3.1"], cm: ["23.0", "7.98"] },
    { us: "7", eu: "37", inch: ["9.3", "3.2"], cm: ["23.5", "8.10"] },
    { us: "7.5", eu: "38", inch: ["9.4", "3.2"], cm: ["24.0", "8.22"] },
    { us: "8", eu: "39", inch: ["9.6", "3.3"], cm: ["24.5", "8.34"] },
    { us: "8.5", eu: "40", inch: ["9.8", "3.3"], cm: ["25.0", "8.46"] },
    { us: "9", eu: "41", inch: ["10.0", "3.4"], cm: ["25.5", "8.58"] },
    { us: "9.5", eu: "42", inch: ["10.2", "3.4"], cm: ["26.0", "8.70"] },
    { us: "10", eu: "43", inch: ["10.4", "3.5"], cm: ["26.5", "8.82"] },
  ];
  const headers = { inch: ["US Size", "EU Size", "Foot Length (IN)", "Width (IN)"], cm: ["US Size", "EU Size", "Foot Length (CM)", "Width (CM)"] };

  const normalize = (value) => String(value || "").trim().replace(/^US\s*/i, "");
  const rowForValue = (value) => {
    const normalized = normalize(value);
    return rows.find((row) => row.us === normalized || row.eu === normalized) || null;
  };

  document.querySelectorAll("[data-bsh-root]:not([data-bsh-ready])").forEach((root) => {
    root.setAttribute("data-bsh-ready", "");
    const drawer = root.querySelector("[data-bsh-drawer]");
    const scrim = root.querySelector("[data-bsh-backdrop]");
    const chartHead = root.querySelector("[data-bsh-chart-head]");
    const chartBody = root.querySelector("[data-bsh-chart-body]");
    const selection = root.querySelector("[data-bsh-selection]");
    const sizeSelect = root.querySelector("[data-bsh-size-select]");
    const lightbox = root.querySelector("[data-bsh-lightbox]");
    const lightboxImage = root.querySelector("[data-bsh-lightbox-image]");
    const propertyInputs = {
      size: root.querySelector('[data-bsh-cart-property="size"]'),
      measurements: root.querySelector('[data-bsh-cart-property="measurements"]'),
    };
    const portal = document.createElement("div");
    portal.className = "bsh__portal";
    document.body.append(portal);
    portal.append(scrim, drawer, lightbox);
    let unit = "inch";

    const getProductForm = () => {
      const scope = root.closest(".product__info-container") || root.closest('[id^="ProductInfo-"]') || document;
      return scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    };
    const selectedOptionElements = (form) => [
      ...form.querySelectorAll('select[name^="options["]'),
      ...form.querySelectorAll('input[name^="options["]:checked'),
      ...form.querySelectorAll('[data-option-value][aria-checked="true"]'),
    ];
    const selectedShoeSize = (form) => {
      if (sizeSelect?.value) return sizeSelect.value;
      if (!form) return "";
      const options = selectedOptionElements(form);
      const named = options.find((element) => /size/i.test(element.name || element.dataset.optionName || ""));
      if (named) return named.value || named.dataset.optionValue || "";
      const matching = options.find((element) => rowForValue(element.value || element.dataset.optionValue));
      return matching ? (matching.value || matching.dataset.optionValue || "") : "";
    };
    const formatMeasurement = (row) => {
      if (!row) return "";
      const values = row[unit];
      const suffix = unit === "cm" ? " cm" : " inch";
      return `EU ${row.eu}; Foot Length: ${values[0]}${suffix}; Width: ${values[1]}${suffix}`;
    };
    const syncCartProperties = () => {
      const form = getProductForm();
      if (!form) return;
      const value = selectedShoeSize(form);
      const row = rowForValue(value);
      if (row && sizeSelect.value !== row.us) sizeSelect.value = row.us;
      propertyInputs.size.value = value;
      propertyInputs.measurements.value = formatMeasurement(row);
      Object.values(propertyInputs).forEach((input) => {
        if (!form.contains(input)) form.append(input);
      });
      selection.textContent = row
        ? `Selected shoe size: US ${row.us} / EU ${row.eu}`
        : "Select a shoe size to view measurements.";
    };
    const renderTable = () => {
      const form = getProductForm();
      const selected = form ? rowForValue(selectedShoeSize(form)) : null;
      const values = headers[unit];
      chartHead.innerHTML = `<tr>${values.map((value) => `<th scope="col">${value}</th>`).join("")}</tr>`;
      chartBody.innerHTML = rows.map((row) => {
        const current = unit === "cm" ? row.cm : row.inch;
        const selectedClass = selected && selected.us === row.us ? " class=\"is-selected\"" : "";
        return `<tr${selectedClass}><th scope="row">${row.us}</th><td>${row.eu}</td><td>${current[0]}</td><td>${current[1]}</td></tr>`;
      }).join("");
    };
    const closeLightbox = () => {
      lightbox.hidden = true;
      lightboxImage.removeAttribute("src");
      if (drawer.hidden) document.body.classList.remove("bsh-open");
    };
    const openLightbox = (trigger) => {
      lightboxImage.src = trigger.dataset.bshZoomSrc;
      lightboxImage.alt = trigger.dataset.bshZoomAlt || "Shoe measurement guide";
      lightbox.hidden = false;
      document.body.classList.add("bsh-open");
      lightbox.querySelector("[data-bsh-lightbox-close]")?.focus();
    };
    const close = () => {
      closeLightbox();
      drawer.dataset.open = "false";
      drawer.setAttribute("aria-hidden", "true");
      drawer.hidden = true;
      scrim.hidden = true;
      document.body.classList.remove("bsh-open");
    };
    const open = () => {
      renderTable();
      drawer.hidden = false;
      scrim.hidden = false;
      drawer.dataset.open = "true";
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("bsh-open");
      drawer.querySelector("button")?.focus();
    };

    root.querySelector("[data-bsh-open]").addEventListener("click", open);
    document.addEventListener("click", (event) => {
      if (!root.contains(event.target) && !drawer.contains(event.target) && !lightbox.contains(event.target) && event.target !== scrim) return;
      const lightboxClose = event.target.closest("[data-bsh-lightbox-close]");
      if (lightboxClose || event.target === lightbox) {
        closeLightbox();
        return;
      }
      const zoomTrigger = event.target.closest("[data-bsh-zoom]");
      if (zoomTrigger) {
        openLightbox(zoomTrigger);
        return;
      }
      if (event.target.closest("[data-bsh-close]") || event.target === scrim) close();
      const unitButton = event.target.closest("[data-bsh-unit]");
      if (unitButton) {
        unit = unitButton.dataset.bshUnit;
        root.querySelectorAll("[data-bsh-unit]").forEach((button) => button.setAttribute("aria-pressed", String(button === unitButton)));
        renderTable();
        syncCartProperties();
      }
    });
    document.addEventListener("change", (event) => {
      const form = getProductForm();
      if (event.target === sizeSelect || (form && form.contains(event.target))) {
        syncCartProperties();
        if (drawer.dataset.open === "true") renderTable();
      }
    });
    document.addEventListener("submit", (event) => {
      const form = getProductForm();
      if (form && event.target === form) syncCartProperties();
    }, true);
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (!lightbox.hidden) closeLightbox();
      else if (drawer.dataset.open === "true") close();
    });
    syncCartProperties();
  });
})();
